import { api } from '../api';
import { tags } from '../tags';
import type { User, UserAzStorage } from '../types';

/* istanbul ignore file */

export const userApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    user: builder.query<User, void>({
      query: () => 'api/user/me/',
      providesTags: (result) => {
        return result
          ? [tags.user, ...result.accounts.map(({ id }) => ({ type: tags.account, id }))]
          : [tags.user, tags.account];
      },
    }),

    userStorageSAS: builder.mutation<UserAzStorage, void>({
      query: () => ({
        url: 'api/user/me/sas/',
        method: 'POST',
      }),
    }),

    updateUser: builder.mutation<User, Partial<User>>({
      query: (data) => ({
        url: 'api/userdetail/me/',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [tags.user, tags.language, tags.levelup],
    }),

    logout: builder.mutation<void, void>({
      query: () => ({
        url: 'api/user/session/',
        method: 'DELETE',
      }),
      invalidatesTags: Object.values(tags),
    }),

    acceptAgreement: builder.mutation<User, void>({
      query: () => ({
        url: 'api/user/me/agreement/',
        method: 'POST',
      }),
      invalidatesTags: [tags.user, tags.account],
    }),

    deleteUser: builder.mutation<User, void>({
      query: () => ({
        url: 'api/user/me',
        method: 'DELETE',
      }),
    }),
  }),
});
